import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';

export const Container = styled.section`
  width: calc(100% - 50px);
  margin: auto;
  @media ${device.tablet} {
    max-width: 1300px;
    width: calc(100% - 150px);
  }
`;

export const Title = styled(Text).attrs({
  as: 'h2',
  family: 'bold',
  align: 'center',
})`
  margin-top: 100px;
  font-size: 44px;

  .header-title {
    font-size: 48px;
  }
`;

export const Description = styled(Text).attrs({
  as: 'p',
  color: color.dimgray,
})`
  text-align: center;

  @media ${device.laptop} {
    text-align: left;
  }
`;

export const Item = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    margin: 20px auto;

    @media ${device.laptop} {
      margin: 20px 0;
    }
  }

  h2 {
    margin-bottom: 10px;
    text-align: center;

    @media ${device.laptop} {
      margin: 20px 0;
      text-align: left;
    }
  }

  @media ${device.laptop} {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
